export default {
  all: 'Sve',
  games: 'Igre',
  playedRecently: 'Nedavno igrane',
  typePrizeDrop: 'Padajuće',
  typeRoulette: 'Rulet',
  typeSlingshot: 'Slingshot',
  typeSlot: 'Slotovi',
  typeOther: 'Ostale',
};
